



















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import Report from "../../models/report/Report";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "../common/AsiCardDetail.vue";
import AsiCardDetailEntry from "../common/AsiCardDetailEntry.vue";
import {BillState, Permissions} from "@/helpers/constants";
import {enumTextFromValue} from "@/helpers/functions_asi";

@Component({
	components: {AsiCardDetailEntry, AsiCardDetail}
})
export default class ReportCardBill extends Vue {

	@Prop({type: Object, default: null})
	public report!: Report | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get isBilled(): boolean {
		return this.report?.bill !== null ?? false;
	}

	private get showBillLink(): boolean {
		if (this.report === null || this.report.bill === null) return false;
		if (!this.isBilling && !this.isCustomer) return false;
		return this.isBilling ? true : this.report.bill.state !== BillState.draft;
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	private get billText(): string | null {
		if (this.report === null || this.report.bill === null) return null;
		return this.report.bill.name ?? this.report.bill.number.toString();
	}

	private get billStateLabel(): string | null {
		if (this.report === null || this.report.bill === null) return null;
		return enumTextFromValue(BillState, this.report.bill.state, true);
	}

	@Emit('reportChanged')
	public reportChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
